<input #invoerveld type="text" [id]="ctrlid" [disabled]="disabled" [placeholder]="placeholder" [(ngModel)]="date"
       (ngModelChange)="gewijzigd($event)" (input)="getypt()" bsDatepicker (blur)="onTouched()"
       [bsConfig]="bsConfig"
       [isDisabled]="disabled"
       [placement]="$any(placement)"
>
